export const AUTH_TOKEN = "auth_token";
export const AUTH_TYPE = "auth_type";
export const AUTH_ROLES = "auth_roles";
export const AUTH_ID = "auth_id";
export const AUTH_NAME = "auth_name";
export const AUTH_USER = "auth_USER";
export const ADMIN_TYPE = "ADMIN";
export const SUBADMIN_TYPE = "Sub Admin";
export const SUBSCRIBER_TYPE = "Subscriber";
export const SUBSCRIBER_EMPLOYEE_TYPE="Subscriber Employee"

export const ContactUsStatus = ["Pending", "Accepted", "Completed", "Rejected"];

export const PASSWORD_FORM_RULES = [
    { required: true, message: "Password is required" },
    { min: 8, message: "Password must have at least 8 characters" },
    {
      pattern:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]+$/,
      message:
        "Password must contain uppercase, lowercase, number and special character (@$!%*?&#)",
    },
    ({ getFieldValue }) => ({
      validator(_, value) {
        const email = getFieldValue("email");
        if (value && email && value === email) {
          return Promise.reject(
            new Error("Password cannot be the same as the email address."),
          );
        }
        return Promise.resolve();
      },
    }),
  ];